import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import apiUrl from '../../Config';

import {
  Box,
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
} from '@mui/material';

const RevenuDetails = () => {
  const location = useLocation();
  const { fromDate, toDate } = location.state || {};
  const [error, setError] = useState('');
  const [revenuDetails, setRevenuDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${apiUrl}/dashboard/earnings/details?fromDate=${fromDate}&toDate=${toDate}`
      );
      setRevenuDetails(res.data?.earnings || []);
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || 'Failed to fetch revenue data';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Box p={3}>
      <Typography variant="h5" gutterBottom>
        Revenue Details
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      ) : revenuDetails.length === 0 ? (
        <Typography>No revenue data available for the selected dates.</Typography>
      ) : (
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Booking ID</TableCell>
                <TableCell>User Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Item Type</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Unit Price</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Total Price</TableCell>
                <TableCell>Total Amount</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {revenuDetails.map((entry) =>
                entry.booking_items?.map((item, idx) => (
                  <TableRow key={`${entry.id}-${idx}`}>
                    <TableCell>{entry.id}</TableCell>
                    <TableCell>{entry.user?.name}</TableCell>
                    <TableCell>{entry.user?.email}</TableCell>

                    {/* Item Type */}
                    <TableCell>
                      {item.book
                        ? 'Book'
                        : item.comboOffer
                        ? 'Combo Offer'
                        : 'N/A'}
                    </TableCell>

                    {/* Book or Combo Title */}
                    <TableCell>
                      {item.book?.title || item.comboOffer?.title || 'N/A'}
                    </TableCell>

                    <TableCell>₹{item.unitPrice}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                    <TableCell>₹{item.totalPrice}</TableCell>

                    {idx === 0 && (
                      <>
                        <TableCell rowSpan={entry.booking_items.length}>
                          ₹{entry.totalAmount}
                        </TableCell>
                        <TableCell rowSpan={entry.booking_items.length}>
                          {new Date(entry.createdAt).toLocaleString()}
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default RevenuDetails;
